import React, { useEffect, useState, useRef } from "react";
import { Modal } from "react-bootstrap";

import * as fCampos from "../JS/campos";

import aspa from "../../assets/img/aspacierre.svg";
import cerrar from "../../assets/img/cerrar.svg";
import icon1 from "../../assets/img/icon1.svg";
import closeall from "../../assets/img/closeall.svg";
import openall from "../../assets/img/abrirtodos.svg";

const ModalCampos = (props) => {
  // STATES
  const [copyConf, setCopyConf] = useState(null); //copia del conf para jugar con él hasta que se le de a aplicar
  const [search, setSearch] = useState(""); // para la busqueda
  const [copyConfs, setCopyConfs] = useState(null); //copia del confs para jugar con él hasta que se le de a aplicar
  const [Error, setError] = useState(""); // error
  
  // REF
  const buscador = useRef();

  // VARIABLES
  const campos_maximo=3;
  let archivo=require('../../config/campos.json');

  // FUNCIONES
  // Para cerrar el modal
  function cierra() {
    props.onHide();
  }
  // Para capturar los cambios de datos del estado de la busqueda
  const handleChange = (event) => {
    setSearch(event.target.value);
  }
  // Para hacer el filtro de la busqueda por nombre
  function filtroCampos(elem) {
    if (
      copyConf[elem].campo & //el campo es para mostrar en campos      
      copyConf[elem].Titulo.toLowerCase().includes(search.toLowerCase()) // filtro de búsqueda    
      ) {
      return true;
    }
    return false;
  }
  // Para hacer el filtro de los seleccionados
  function filtroCamposSeleccionados(elem) {
    if (
      copyConf[elem].campo & //el campo es para mostrar en campos
      (copyConf[elem].seleccionado === true)// no esta seleccionado
    ) {
      return true;
    }
    return false;
  }
  // Effec para cada vez que abre y cierra el modal
  useEffect(() => {
    //Se acaba de abrir
    if(props.show){
    setSearch("");
    setCopyConf(fCampos.copy(props.campos));
    setCopyConfs(fCampos.copy(props.Confs));
    }
  }, [props.show, props.campos, props.Confs]);

  if (!props.show|!copyConf|!props.campos|!copyConfs)
  	return("")
  else
  return (
    
    <Modal
      className="modal_campos"
      show={props.show}
      onHide={props.onHide}
      animation={false}
      centered
      size="lg"
    >
      
      <div id="modalcampos">
        <Modal.Body>
          <div className="contmodal fondoazul modales_campos col-xs-12">

          <div className="col-xs-12 nopadding" >
            <div className="col-xs-6 titular_modal mt-n1 nopadding">
              <img src={icon1} alt="icono" className="icocampos" />
              <h2>Datos</h2>
            </div>
            <div className="col-xs-6 contaspacierre nopadding">
              <div
                onClick={() => {
                  cierra();
                }}
                className="aspacierre"
              >
                <img src={cerrar} alt="cerrar" className="icocerrar" />
              </div>
            </div>
            </div>

            <div className="col-xs-12 nopadding">
              <h4>Datos seleccionados<strong> {copyConfs.campos.length} de {campos_maximo}</strong></h4>
            </div>

            <div className="cont_fondocampos col-xs-12 nopadding">
              <div className="fondocampos col-xs-12">
                <ul>
                    {
                      copyConfs.campos &&
                      Object.keys(copyConfs.campos).map(
                        (elem) => (     
                            <li
                              className="filtro_added"
                              onClick={() => {}}
                              key={elem}
                            >
                              <>
                                <div className="ciz">
                                    <h5>{archivo[copyConfs.campos[elem]].Titulo}</h5>
                                    <small>{archivo[copyConfs.campos[elem]].Descripcion}</small>
                                </div>
                                <div className="cde">
                                  <span>
                                    <img
                                      onClick={() => {
                                        let aux ={...copyConfs};
                                        aux.campos = aux.campos.filter(function(i) { return i !== copyConfs.campos[elem] }); // filtramos                               
                                        setCopyConfs(aux);
                                        copyConf && Object.keys(copyConf).forEach(id=>{
                                          if (copyConf[id].nombre===copyConfs.campos[elem]) copyConf[id].seleccionado=false;
                                        })
                                      }}
                                      src={aspa}
                                      alt="cerrar filtro"
                                    />
                                  </span>
                                </div>
                              </>
                            </li>
                          )
                      )}                    
                </ul>
              </div>

              {
              copyConf && (Object.keys(copyConf).filter(filtroCamposSeleccionados).length > 0) &&
                <div className="col-xs-12 btn_quitartodos conbtn">
                  <button
                    onClick={() => {
                      copyConf &&
                        Object.keys(copyConf).map(
                          (elem) =>
                            copyConf[elem].campo &&
                            copyConf[elem].seleccionado === true && (
                              <>
                                {(copyConf[elem].seleccionado = false)}
                              </>
                            )
                        );
                        let aux ={...copyConfs};                  
                        aux.campos= [];
                        setCopyConfs(aux);
                    }}
                    className="btn_quitartodos"
                  >
                    Quitar todos
                    <span>
                      {" "}
                      <img
                        src={closeall}
                        alt="quitar todos"
                        className="icocampos"
                      />
                    </span>
                  </button>
                </div>
              }
            </div>

            <div className="col-xs-12 nopadding">
              <hr />
            </div>
            <div className="col-xs-12 nopadding">
              <div className="categorias col-xs-12">
                <div className="cabecera nopadding col-xs-12">
                  <div className="nopadding col-xs-6">
                    <input
                      ref={buscador}
                      type="search"
                      id="site-search"
                      name=""
                      placeholder="Buscar"
                      className="mr-2"
                      onChange={handleChange}
                      defaultValue={search}
                    />
                    en{" "}
                    <strong>
                      {copyConf ? (
                        Object.keys(copyConf).filter(filtroCampos).length
                      ) : (
                        <p>0</p>
                      )}
                    </strong>{" "}
                    datos
                  </div>
                  <div className="nopadding col-xs-6">
                  </div>
                </div>
                <div className="cont_fondocampos_bd col-xs-12">
                  <div className="fondocampos col-xs-12">
                    <ul>
                      {copyConf &&
                        Object.keys(copyConf)
                          .filter(filtroCampos)
                          .map(
                            (elem) =>
                              copyConf[elem].campo &&
                              copyConf[elem].tipo === "campo" &&(
                                <li
                                  className="filtro_added"
                                  onClick={() => {
                                    setError('');
                                    if (copyConf[elem].seleccionado) {
                                      copyConf[
                                        elem
                                      ].seleccionado = false;
                                      let aux ={...copyConfs};
                                      aux.campos = aux.campos.filter(function(i) { return i !== copyConf[elem].nombre }); // filtramos
                                      setCopyConfs(aux);
                                    } else {
                                      if(copyConfs.campos.length<=campos_maximo){
                                      copyConf[
                                        elem
                                      ].seleccionado = true;
                                      let aux ={...copyConfs};
                                      aux.campos.push(copyConf[elem].nombre);
                                      setCopyConfs(aux);
                                    }
                                  }
                                  }}
                                  key={elem}
                                  style={{cursor:'pointer'}}
                                >
                                  <>
                                    <div className="ciz">
                                    <h5>{archivo[copyConf[elem].nombre].Titulo}</h5>
                                    <small>{archivo[copyConf[elem].nombre].Descripcion}</small>
                                    </div>
                                  </>
                                  <div className="cde">
                                    <input
                                      type="checkbox"
                                      onChange={() => {}}
                                      id={copyConf[elem].nombre}
                                      checked={copyConf[elem].seleccionado}
                                    />
                                  </div>
                                </li>
                              )
                          )}
                    </ul>
                  </div>
                </div>
                
              </div>
              {
              copyConf && (Object.keys(copyConf).filter(filtroCamposSeleccionados).length < 3) &&
              <div className="cont_fondocampos col-xs-12 nopadding">
                <div className="col-xs-12 martop5 conbtn ">
                  <button
                    onClick={() => {
                      setError('');
                      let aux ={...copyConfs};
                      //no hay agregaciones
                      copyConf &&
                      Object.keys(copyConf).map(
                        (elem) =>
                          copyConf[elem].campo &&
                          copyConf[elem].seleccionado === false && (
                            <>
                              {(copyConf[elem].seleccionado = true)}
                              {aux.campos.push(copyConf[elem].nombre)}
                            </>
                          )
                      );                    
                      setCopyConfs(aux);
                    }}
                    className="button_limpiar_aside btn_quitartodos"
                  >
                    Marcar todos{" "}
                    <span>
                      <img
                        src={openall}
                        alt="quitar todos"
                        className="icocampos"
                      />
                    </span>
                  </button>
                </div>
              </div>
            }
            </div>
            
          </div>
          
        </Modal.Body>
        <div className='error col-xs-12'>
                <span>
                {/* {state.ErrorFinal===false?'':'No puede subir la imagen, hay errores en los datos'} */}
                {Error && Error}
                </span>
        </div>
      </div>

      <Modal.Footer>
        <button
          className="cancelar"
          style={{ width: "18%" }}
          onClick={() => {            
            props.onHide();
          }}
        >
          Cancelar
        </button>
        <button
          className="aplicar"
          style={{ width: "18%" }}
          onClick={() => {
            if (copyConfs.campos.length>0){
              props.setCargando(true);
              props.setCampos(copyConf);
              props.setConfs(copyConfs);
              props.onHide();
            }else{
              setError('Mínimo un campo seleccionado')
            }
           
          }}
        >
          Aplicar
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalCampos;
